// extracted by mini-css-extract-plugin
export default {"loading":"Spinner_loading__h7BAE","spinner":"Spinner_spinner__Ld683","err":"Spinner_err__OAn6i","profileinput":"Spinner_profileinput__Bfd3S"};